<template>
  <b-container fluid style="min-height: calc(100vh - 185px)" class="p-0 m-0 h-100">
    <b-card id="card-principal" class="mb-0 pb-0 h-100">
      <b-row class="m-0 h-100">
        <template #header>
          <i class="fas fa-edit"></i>
          <strong>{{$lang.PCI.Layouts.Title}}</strong>
        </template>
      </b-row>
      <b-row>
          <Tables ref="tableGrid" class="col-md-5 mb-3 tabela"
                  :columns="[$lang.PCI.Layouts.DataTable.Description,
                            $lang.Common.DataTable.Actions]"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  :showPaging="false"
                  :showHeader="false"
                  v-on:Load="onLoad">
            <tr v-for="obj in this.objList" v-bind:key="obj.id">
              <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.descricao" />
              <TableColumn :HasChange="false" :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
            </tr>
          </Tables>

          <forms :title="$lang.PCI.Layouts.Title"
                 class="col-md-7 m-0 h-100"
              :showClearButton="true"
              :showSaveButton="true"
              v-on:Clear="onClearForm"
              v-on:Save="onSave">
            <div class="form-group row">
              <div class="col-md-10 mb-3">
                <label for="txtDescricao"><small v-if="form.descricao.required">* </small>{{$lang.PCI.Layouts.LabelDescription}}:</label>
                <b-form-input type="text"
                    name="txtDescricao"
                    ref="txtDescricao"
                    :placeholder="$lang.PCI.Layouts.PlaceholderDescription"
                    v-model="form.descricao.value"
                    :required="form.descricao.required"
                    :state="form.descricao.state" />
              </div>
            </div>
            <div class="treeview-content itens">
              <item-tree-view
                ref="pciTreeview"
                :list="pciItemsTree"
                :showCheckbox="true"
                :serializer="p => p.name"
              >
              </item-tree-view>
            </div>
          </forms>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import Layouts from './layouts'
export default Layouts
</script>

<style scoped>
  .itens {
    height: calc(100vh - 555px);
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/layouts/layouts.vue